<div class="header py-4" [ngStyle]="{'background-color': isDevelopmentMode || isTestMode ? '#B22222' : '#FFF'}">
  <div class="container">
    <div class="d-flex justify-content-between align-items-center">
      <div class="header-brand">
        <img *ngIf="!isDevelopmentMode && !isTestMode" src="/assets/img/logo.svg" class="logo" alt="Logo" width="45" height="45">
        <img *ngIf="isDevelopmentMode || isTestMode" src="/assets/img/logo-white.svg" class="logo" alt="Logo" width="45" height="45">
      </div>

      <h2 class="mb-0" *ngIf="isDevelopmentMode" style="color:#FFF">DEVELOPMENT</h2>
      <h2 class="mb-0" *ngIf="isTestMode" style="color:#FFF">TEST</h2>

      <div class="d-flex">
        <div class="dropdown" ngxClickElsewhere (clickElsewhere)="isShowing = false">
          <div class="nav-link pr-0 leading-none" (click)="showHideMenu()">
            <span class="avatar" [style.backgroundImage]="'url('+ user.photo +')'"></span>
            <span class="ml-2 d-none d-lg-block">
                      <span class="text-default">{{ user.name }}</span>
                      <small class="text-muted d-block mt-1">{{ user.role }}</small>
                    </span>
          </div>
          <div class="dropdown-menu dropdown-menu-right dropdown-menu-arrow" [class.show]="isShowing">
            <a class="dropdown-item" [routerLink]="['/user/profile']">
              <i class="dropdown-icon fa fa-user-circle"></i> Profil
            </a>
            <a class="dropdown-item" [routerLink]="['/user/list']" *ngIf="permissionHelper.userPages.includes('user')">
              <i class="dropdown-icon fa fa-users"></i> Korisnici
            </a>
            <div class="dropdown-divider"></div>
            <a href class="dropdown-item" (click)="onSignout()">
              <i class="dropdown-icon fa fa-sign-out-alt"></i> Odjavi se
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<div class="header py-0 mb-6">
  <div class="container">
    <div class="row align-items-center">
      <div class="col-lg order-lg-first">
        <ul class="nav nav-tabs border-0 flex-column flex-lg-row justify-content-center">
          <ng-container *ngFor="let link of links">
            <div class="dropdown" ngxClickElsewhere (clickElsewhere)="link.isOpen = false">
              <li class="nav-item mr-20" *ngIf="isTabVisible(link)" (click)="toggleLink(link)">
                <a class="nav-link border-0 mr-15"
                   [class.active]="link.isOpen || isSomeSublinkActive(link)">
                  <i class="fa fa-{{link.icon}}"></i>
                  {{ link.name }}
                </a>
                <i class="fa fa-chevron-{{ link.isOpen ? 'up' : 'down' }}"></i>
              </li>
              <div class="dropdown-menu mt-0" [class.show]="link.isOpen">
                <div class="d-flex flex-column" *ngFor="let sublink of link.sublinks">
                  <a class="dropdown-item"
                     *ngIf="permissionHelper.userPages.includes(sublink.link)"
                     (click)="link.isOpen = false"
                     [routerLink]="['/' + getReportRoute(sublink)]"
                     [routerLinkActive]="['active']">
                    <i class="dropdown-icon fa fa-{{sublink.icon}}"></i> {{ sublink.name }}
                  </a>
                </div>
              </div>
            </div>
          </ng-container>
        </ul>
      </div>
    </div>
  </div>
</div>
